export default function arrayUtils() {
  return {
    moveUp: (array: Array<any>, index: number) => {
      let arr = [...array];
      if (index > 0) {
        let el = arr[index];
        arr[index] = arr[index - 1];
        arr[index - 1] = el;
      }
      return arr;
    },
    moveDown: (array: Array<any>, index: number) => {
      let arr = [...array];
      if (index !== -1 && index < arr.length - 1) {
        let el = arr[index];
        arr[index] = arr[index + 1];
        arr[index + 1] = el;
      }
      return arr;
    },
  };
}
